/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClipboardCheckAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6.998 2h10v2h4v18h-18V4h4zm2 2v2h6V4zm8 4h-10V6h-2v14h14V6h-2z" />
        <path d="M15.707 12.707 11 17.414l-2.707-2.707 1.414-1.414L11 14.586l3.293-3.293z" />
      </g>
    </g>
  </Icon>
);
export { SvgClipboardCheckAlt as ClipboardCheckAlt };
